export const images = {
    init: function() {
        const $ = jQuery;

        $('#mobile-images').slick({
            arrows: false,
            dots: false,
            autoplay: true,
            fade: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            speed: 5000,
        });
    }
}